import React, { useState } from 'react';
import { FileText, Table, Loader2, Download } from 'lucide-react';
import { exportApi } from '../api';
import { toast } from 'sonner';

const ExportButtons = ({ module, moduleName, filters = {}, className = '' }) => {
  const [exporting, setExporting] = useState(null);
  
  // Support both module and moduleName props
  const moduleToExport = module || moduleName;

  const handleExport = async (format) => {
    try {
      setExporting(format);
      const response = await exportApi.download(moduleToExport, format, filters);
      
      // Create download link
      const blob = new Blob([response.data], {
        type: format === 'pdf' 
          ? 'application/pdf' 
          : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Get filename from response headers or generate one
      const contentDisposition = response.headers['content-disposition'];
      let filename = `${moduleToExport}_${new Date().toISOString().split('T')[0]}.${format === 'pdf' ? 'pdf' : 'xlsx'}`;
      if (contentDisposition) {
        const match = contentDisposition.match(/filename=(.+)/);
        if (match) filename = match[1];
      }
      
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success(`Exportação ${format.toUpperCase()} concluída!`);
    } catch (error) {
      console.error('Export error:', error);
      toast.error('Erro ao exportar dados');
    } finally {
      setExporting(null);
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <button
        onClick={() => handleExport('excel')}
        disabled={exporting !== null}
        className="btn-secondary text-sm"
        data-testid="export-excel-btn"
        title="Exportar para Excel"
      >
        {exporting === 'excel' ? (
          <Loader2 className="animate-spin" size={16} />
        ) : (
          <Table size={16} />
        )}
        Excel
      </button>
      <button
        onClick={() => handleExport('pdf')}
        disabled={exporting !== null}
        className="btn-secondary text-sm"
        data-testid="export-pdf-btn"
        title="Exportar para PDF"
      >
        {exporting === 'pdf' ? (
          <Loader2 className="animate-spin" size={16} />
        ) : (
          <FileText size={16} />
        )}
        PDF
      </button>
    </div>
  );
};

export default ExportButtons;
